import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ProfilSchedule from './ProfilSchedule';

function ProfilScheduleTab({ playerId, onDataLoaded }) {
  const { t } = useTranslation();
  useEffect(() => {
    // Appeler onDataLoaded si fourni pour indiquer que l'onglet a des données
    if (onDataLoaded) {
      // On supposera que si le composant est rendu, il y a des données
      // Le composant ProfilSchedule gère sa propre logique de chargement
      onDataLoaded(true);
    }
  }, [onDataLoaded, playerId]);

  if (!playerId) {
    return null;
  }

  return <ProfilSchedule playerId={playerId} />;
}

export default ProfilScheduleTab;